import styled from 'styled-components';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { errorMessages } from '@/utils/errorMessages';

const IndicatorContainer = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colors.error};
  color: white;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  z-index: 9999;
  direction: rtl;
  box-shadow: ${({ theme }) => theme.shadows.md};
  animation: slideDown 0.3s ease-in-out;

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

const Icon = styled.span`
  margin-left: ${({ theme }) => theme.spacing.xs};
`;

const OfflineIndicator: React.FC = () => {
  const isOnline = useOnlineStatus();

  // Don't render anything when online
  if (isOnline) {
    return null;
  }

  return (
    <IndicatorContainer $isVisible={true}>
      <Icon>📡</Icon>
      {errorMessages.offline}
    </IndicatorContainer>
  );
};

export default OfflineIndicator;
